import { type FC } from 'react';
import { Badge } from 'dibs-elements/exports/Badge';
import { Link } from 'dibs-elements/exports/Link';
import { trackRelatedSearchClick } from '../helpers/trackingHelpers';
import { buildPhotosUrl } from './helpers/buildPhotosUrl';

import styles from './RelatedPhotosPill.scss';

import { type PhotoTagType } from './types';

type Props = {
    isRoomTypeFacet: boolean;
    roomTag?: PhotoTagType | null;
    facet: {
        name: string | null;
        label: string | null;
    };
};

const RelatedPhotosPill: FC<Props> = props => {
    const { isRoomTypeFacet, facet, roomTag } = props;

    const facetLabel = facet.label || '';
    const roomUrlLabel = roomTag?.urlLabel || '';

    let photosUrl = '/photos/';
    let displayName = facet.name || '';

    if (isRoomTypeFacet) {
        photosUrl = buildPhotosUrl(null, facetLabel);
    } else {
        photosUrl = buildPhotosUrl(facetLabel, roomUrlLabel);
        if (roomUrlLabel) {
            displayName = `${displayName} ${roomTag?.name || ''}`;
        }
    }

    return (
        <Link
            className={styles.link}
            href={photosUrl}
            onClick={() => trackRelatedSearchClick({ label: 'photo' })}
        >
            <Badge type="pill" size="medium-regular" interactive>
                {displayName}
            </Badge>
        </Link>
    );
};

export default RelatedPhotosPill;
